import { useQuery } from '@tanstack/react-query';
import { useAppSettingsStore } from '@/shared/lib';
import type { CryptoAddressCheckResponse } from '../../model';
import { checkCryptoAddress } from '../requests';

interface UseCryptoAddressCheckOptions {
  network: string;
  address: string;
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
}

export function useCryptoAddressCheck({
  network,
  address,
  enabled = true,
}: UseCryptoAddressCheckOptions) {
  const { language } = useAppSettingsStore();
  const queryKey = ['cryptoAddressCheck', network, address, language];

  const query = useQuery<CryptoAddressCheckResponse, Error>({
    queryKey,
    queryFn: async () => {
      return await checkCryptoAddress(network, address);
    },
    enabled: enabled && !!network && !!address && address.length > 0,
    retry: 0,
  });

  return {
    checkAddressData: query.data,
    isCheckingAddress: query.isLoading,
    isCheckingAddressError: query.isError,
    isAddressCheckFetching: query.isFetching,
    checkingAddressError: query.error,
  };
}
